import { authApi } from "../api";

/* turn any error into a plain string */
function toMessage(e: unknown): string {
  if (e && typeof e === "object" && "response" in e) {
    const resp = (e as any).response;
    if (resp?.data?.detail) return resp.data.detail;
    if (resp?.data?.message) return resp.data.message;
  }
  if (e && typeof e === "object" && "message" in e) return (e as any).message;
  return typeof e === "string" ? e : "Unknown error";
}

/* ---------- helpers ---------- */
export async function sendCode(phone: string) {
  try {
    await authApi.sendSmsCode(phone);
    return { ok: true as const };
  } catch (err) {
    return { ok: false as const, message: toMessage(err) };
  }
}

export async function checkCode(phone: string, code: string) {
  try {
    const data = await authApi.checkSmsCode(phone, code);
    return { ok: true as const, verified: data?.verified ?? true };
  } catch (err) {
    return { ok: false as const, message: toMessage(err), verified: false };
  }
}
